import { defineMessage } from 'react-intl';

import { Position } from '#src/__generated__/globalTypes.ts';

export const createATeamData = {
  goalkeepers: {
    position: Position.Goalkeeper,
    instructions: defineMessage({
      id: 'HowToPlay.CreateATeam.goalkeeperInstructions',
      defaultMessage:
        "Use details like each player's recent performances, the strength of their upcoming opponents, their likelihood to start, and your own expertise to build the best team possible.",
    }),
    player1: {
      cardSlug: 'damian-emiliano-martinez-2025-limited-277',
      playerSlug: 'damian-emiliano-martinez',
    },
    player2: {
      cardSlug: 'dominik-greif-2025-limited-781',
      playerSlug: 'dominik-greif',
    },
  },
  defenders: {
    position: Position.Defender,
    instructions: defineMessage({
      id: 'HowToPlay.CreateATeam.defenderInstructions',
      defaultMessage:
        "Use details like each player's recent performances, the strength of their upcoming opponents, their likelihood to start, and your own expertise to build the best team possible.",
    }),
    player1: {
      cardSlug: 'chancel-mbemba-mangulu-2025-limited-213',
      playerSlug: 'chancel-mbemba-mangulu',
    },
    player2: {
      cardSlug: 'nico-schlotterbeck-2025-limited-587',
      playerSlug: 'nico-schlotterbeck',
    },
  },
  midfielders: {
    position: Position.Midfielder,
    instructions: defineMessage({
      id: 'HowToPlay.CreateATeam.midfielderInstructions',
      defaultMessage:
        "Use details like each player's recent performances, the strength of their upcoming opponents, their likelihood to start, and your own expertise to build the best team possible.",
    }),
    player1: {
      cardSlug: 'moises-isaac-caicedo-corozo-2025-limited-820',
      playerSlug: 'moises-isaac-caicedo-corozo',
    },
    player2: {
      cardSlug: 'dominik-szoboszlai-2025-limited-835',
      playerSlug: 'dominik-szoboszlai',
    },
  },
  forwards: {
    position: Position.Forward,
    instructions: defineMessage({
      id: 'HowToPlay.CreateATeam.forwardInstructions',
      defaultMessage:
        "Use details like each player's recent performances, the strength of their upcoming opponents, their likelihood to start, and your own expertise to build the best team possible.",
    }),
    player1: {
      cardSlug: 'erling-haland-2025-limited-827',
      playerSlug: 'erling-haland',
    },
    player2: {
      cardSlug: 'harry-kane-2025-limited-634',
      playerSlug: 'harry-kane',
    },
  },
  extras: {
    position: 'Extra Player' as Position,
    instructions: defineMessage({
      id: 'HowToPlay.CreateATeam.extraPlayerInstructions',
      defaultMessage:
        "Use details like each player's recent performances, the strength of their upcoming opponents, their likelihood to start, and your own expertise to build the best team possible.",
    }),
    player1: {
      cardSlug: 'kylian-mbappe-lottin-2025-limited-712',
      playerSlug: 'kylian-mbappe-lottin',
    },
    player2: {
      cardSlug: 'harry-kane-2025-limited-634',
      playerSlug: 'harry-kane',
    },
  },
};
